import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { KioskService } from '../kiosk.service';

@Component({
  selector: 'app-kiosk-diagnostics-dialog',
  templateUrl: './kiosk-diagnostics-dialog.component.html',
  styleUrls: ['./kiosk-diagnostics-dialog.component.css']
})
export class KioskDiagnosticsDialogComponent implements OnInit {
  loading = false;
  resp: any;
  constructor(
    public dialogRef: MatDialogRef<KioskDiagnosticsDialogComponent>,
    private _kioskService: KioskService,
    public snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: { kiosk: any }) { }


  ngOnInit() {
    this.loading = true;

    this._kioskService.getKioskDiagnostics(this.data.kiosk.id).subscribe((d) => {
      this.resp = d;
      this.loading = false;
    });
  }



}



// WEBPACK FOOTER //
// ./src/app/kiosk-diagnostics-dialog/kiosk-diagnostics-dialog.component.ts